<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      RepairPluSel: ["Services", "Computer Repairs", "Plumbing"],
      OfferSelc: ["Offer Percentage", "25%"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
          >
            <h4>Offers</h4>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <span class="fs-14 me-2">Sort</span>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Newly Added
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active">Ascending</a>
                  <a href="javascript:void(0);" class="dropdown-item">Descending</a>
                </div>
              </div>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active"
                    >Export as PDF</a
                  >
                  <a href="javascript:void(0);" class="dropdown-item">Export as Excel</a>
                </div>
              </div>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-printer"></i
              ></a>
              <a
                href="javascript:void(0);"
                class="tags active d-flex justify-content-center align-items-center border rounded me-2"
                id="filter_search"
                @click="toggleFilterInputs"
                ><i class="ti ti-sort-descending"></i
              ></a>
              <a
                href="javascript:void(0);"
                class="btn btn-dark d-flex justify-content-center align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#add-offer"
                ><i class="ti ti-circle-plus me-2"></i>Add Offer</a
              >
            </div>
          </div>
          <div
            id="filter_inputs"
            v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
          >
            <div class="row">
              <div class="col-lg-4 col-md-6 col-xl">
                <div class="mb-3">
                  <div class="sel-cal Calendar-icon">
                    <span><i class="ti ti-calendar-month"></i></span>
                    <date-picker
                      v-model="startdate"
                      placeholder=""
                      class="datetimepicker form-control"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="RepairPluSel"
                    id="repairplusel"
                    placeholder="Services"
                  />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="OfferSelc"
                    id="offerselc"
                    placeholder="Offer Percentage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Service</th>
                    <th>Amount</th>
                    <th>Offer</th>
                    <th>Offer Price</th>
                    <th>Date</th>
                    <th>End Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-15.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">Computer Repair</router-link>
                        </h6>
                      </div>
                    </td>
                    <td>$80</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>28 Sep 2024</td>
                    <td>30 Sep 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-17.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">Steam Car Wash</router-link>
                        </h6>
                      </div>
                    </td>
                    <td>$30</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>18 Oct 2024</td>
                    <td>22 Oct 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-19.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details">House Cleaning </router-link>
                        </h6>
                      </div>
                    </td>
                    <td>$40</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>20 Oct 2024</td>
                    <td>28 Oct 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-14.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Building Construction</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>$90</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>03 Nov 2024</td>
                    <td>07 Nov 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-16.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Interior Designing</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>$60</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>12 Nov 2024</td>
                    <td>15 Nov 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-23.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Plumbing Services</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>$50</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>15 Nov 2024</td>
                    <td>18 Dec 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/providers/provider-13.jpg"
                            class="rounded"
                            alt="user"
                          />
                        </router-link>
                        <h6 class="fs-14">
                          <router-link to="/details/service-details"
                            >Car Repair Services</router-link
                          >
                        </h6>
                      </div>
                    </td>
                    <td>$60</td>
                    <td>25%</td>
                    <td>$20</td>
                    <td>13 Oct 2024</td>
                    <td>14 Oct 2024</td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="#"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-offer"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="#"
                          class=""
                          data-bs-toggle="modal"
                          data-bs-target="#del-offer"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-offers-modal></provider-offers-modal>
  </div>
</template>
